import { styles as commonStyles } from '../../../../../assets/common.scss';
import { styles as styleHelpersStyles } from '../../../../../assets/style-helpers.scss';
import { styles as flexboxHelpersStyles } from '../../../../../assets/flexbox-helpers.scss';
import { styles as componentStyles } from './view.scss';
import { unsafeCSS } from 'lit';

export const styles = [
  unsafeCSS(`${commonStyles}`),
  unsafeCSS(`${styleHelpersStyles}`),
  unsafeCSS(`${flexboxHelpersStyles}`),
  unsafeCSS(`${componentStyles}`),
];
